import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { openModal } from "risa-oasis-ui_v2";
import CustomTable from "../../../../components/custom-table/custom-table";
import DocViewerModal from "../../../../components/modals/docViewerModal/docViewerModal";
import { ModalId } from "../../../../enums/modalId";
import { closeModal } from "../../../../redux/slice/modalSlice";
import { AppDispatch, RootState } from "../../../../redux/store/store";
import {
  generateJCodeDocsTableData,
  JCodeDocsTableTableColumns,
} from "../../utils/generateTableDataForJcodeDocs";

const JCodeDocuments = () => {
  const { singleMedicalPaOrder } = useSelector(
    (state: RootState) => state.singleMedicalPaOrder,
  );
  const { data: authStatusOptions } = useSelector(
    (state: RootState) => state.authStatusOptions,
  );
  const { metaData, openedModalId } = useSelector(
    (state: RootState) => state.modal,
  );
  const [tableData, setTableData] = useState<any[]>([]);

  const dispatch = useDispatch<AppDispatch>();

  useEffect(() => {
    if (singleMedicalPaOrder) {
      const jCodeDocsTableData = generateJCodeDocsTableData(
        singleMedicalPaOrder,
        authStatusOptions,
      );

      setTableData(jCodeDocsTableData || []);
    }
  }, [singleMedicalPaOrder, authStatusOptions]);

  useEffect(() => {
    if (openedModalId === ModalId.DOC_VIEWER_MODAL) {
      openModal(ModalId.DOC_VIEWER_MODAL);
    }
    if (openedModalId === ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION) {
      openModal(ModalId.DOC_VIEWER_WITH_SIDE_NAVIGATION);
    }
  }, [openedModalId, metaData]);

  return (
    <div className="jcode-documnets--container">
      <CustomTable
        tableHeaders={JCodeDocsTableTableColumns}
        tableData={tableData}
        tableName="jcode_documents"
        pagesPerView={tableData.length}
        itemsPerPage={20}
        count={tableData.length}
        hideSearchBar={true}
        hidePagination={true}
      />
      {openedModalId === ModalId.DOC_VIEWER_MODAL && (
        <DocViewerModal
          type="clinical_attachment"
          onClose={() => dispatch(closeModal())}
        />
      )}
    </div>
  );
};

export default JCodeDocuments;
